import { Grid, Typography } from "@mui/material";
import CouponIllustration from "assets/images/illustrations/NoCoupons.png";
import theme from "assets/theme";
import FaiBox from "MuiComponents/FaiBox";
import FaiTypography from "MuiComponents/FaiTypography";
import FaiButton from "MuiComponents/FaiButton";
import PageHeader from "screens/OnBoarding/components/PageHeader";

function NoCoupons({ onAddNew = () => {} }) {
	const { palette, borders } = theme;

	return (
		<FaiBox
			bgColor={palette.white.main}
			className={"container items-center coupon-form-content"}
			borderRadius={borders.borderRadius.md}
			verticalAlign="middle"
		>
			<Grid container spacing={8} style={{ alignItems: "center" }}>
				<Grid item xs={12} sm={6}>
					<FaiBox className="flex flex-col gap-5">
						<PageHeader
							title="No Active Coupons"
							content="It looks like you don't have any active coupons at the moment. Add
							a coupon to start offering discounts to your customers."
						/>
						<FaiBox>
							<FaiButton
								color="primary"
								variant={"contained"}
								fullWidth
								onClick={onAddNew}
							>
								Add new Coupon
							</FaiButton>
						</FaiBox>
					</FaiBox>
				</Grid>

				<Grid item xs={12} sm={6}>
					<FaiBox
						component={"img"}
						width="100% !important"
						height="auto !important"
						src={CouponIllustration}
					/>
				</Grid>
			</Grid>
		</FaiBox>
	);
}
export default NoCoupons;
